import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '../../atoms/Input';
import { Button } from '../../atoms/Button';
import { Card } from '../../atoms/Card';

export interface UserSearchBarProps {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  onSearch: (e: React.FormEvent) => void;
}

export const UserSearchBar = ({
  searchQuery,
  onSearchQueryChange,
  onSearch,
}: UserSearchBarProps) => {
  return (
    <Card className="mb-6">
      <form onSubmit={onSearch} className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
        <div className="flex-1 relative min-w-0">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
          <Input
            type="text"
            placeholder="Kullanıcı adı, e-posta veya ID ile ara..."
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
            className="pl-10"
          />
        </div>
        <Button type="submit" variant="primary" className="w-full sm:w-auto">
          Ara
        </Button>
      </form>
    </Card>
  );
};
